var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center padding-3"},[_c('div',{staticClass:"bg-gray-4"},[_vm._t("default",null,{"dataTestid":_vm.dataTestid})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }